import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A lookup-by-id input.
 *
 * Several PRD pages address an object that the current route does not carry in
 * its path (`/workspace/billing` has no `:orderId`, `/workspace/quality` has no
 * `:inspectionId`). Those pages are real operator tools — an accountant looks
 * up an order, a QA lead looks up an inspection — so instead of inventing a row
 * list we ask for the identifier and read the aggregate by id.
 *
 * The input trims and validates the shape client-side only to spare a pointless
 * round trip; the service remains the authority.
 */
import { Field } from "./ui.js";
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const isUuid = (v) => UUID_RE.test(v.trim());
export function IdInput({ label = "对象 ID", value, onChange, placeholder = "粘贴 UUID", hint, }) {
    return (_jsx(Field, { label: label, hint: hint, children: _jsx("input", { className: "input mono", value: value, placeholder: placeholder, spellCheck: false, onChange: (e) => onChange(e.target.value.trim()) }) }));
}
/** Read-only banner explaining why a page asks for an id instead of listing. */
export function LookupNotice({ what, listEndpoint }) {
    return (_jsxs("div", { className: "notice notice--info", children: ["\u672C\u9875\u6309 ID \u67E5\u8BE2", what, "\u3002", listEndpoint ? (_jsxs(_Fragment, { children: [" ", "\u805A\u5408\u5217\u8868\u63A5\u53E3 ", _jsx("code", { children: listEndpoint }), " \u5C1A\u672A\u51BB\u7ED3\u4E3A\u5951\u7EA6\u8BFB\u64CD\u4F5C\uFF0C\u56E0\u6B64\u4E0D\u5C55\u793A\u65E0\u6CD5\u8BC1\u5B9E\u7684\u884C\u3002"] })) : (" 输入标识符后直接读取该对象的真实聚合。")] }));
}
